import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { PROXY } from "../../lib/utils";
import { apiErrorMessage, passwordIssue, passwordMessage } from "../../lib/passwordPolicy";

export default function VerifyEmail() {
  const { t } = useTranslation();
  const token = useRef(new URLSearchParams(window.location.hash.slice(1)).get("token") ||
    new URLSearchParams(window.location.search).get("token")).current;
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);
  const [verified, setVerified] = useState(false);
  const validToken = /^[a-f0-9]{64}$/i.test(token || "");

  useEffect(() => {
    window.history.replaceState(null, "", "/verify-email");
  }, []);

  const verify = async (event) => {
    event.preventDefault();
    const issue = passwordIssue(password);
    if (!validToken || issue || password !== confirmPassword) {
      setMessage(issue ? passwordMessage(issue, t) :
        (validToken ? t("validation.password-match") : t("emailVerification.invalidLink")));
      return;
    }
    setBusy(true);
    setMessage("");
    try {
      await axios.post(`${PROXY}/users/verify-email`, { token, password, confirmPassword });
      setVerified(true);
      setPassword("");
      setConfirmPassword("");
      setMessage(t("emailVerification.success"));
    } catch (error) {
      setMessage(apiErrorMessage(error.response?.data, t));
    } finally {
      setBusy(false);
    }
  };

  return <main className="mx-auto max-w-lg px-6 py-20 text-center">
    <h1 className="text-2xl font-semibold">{t("emailVerification.title")}</h1>
    {!validToken && <p className="mt-5" role="alert">{t("emailVerification.invalidLink")}</p>}
    {validToken && !verified && <form onSubmit={verify} className="mt-6 space-y-4 text-left">
      <p>{t("emailVerification.setPassword")}</p>
      <p className="text-sm text-gray-600">{t("validation.password_hint")}</p>
      <label className="block">{t("form.your-password")}
        <input className="mt-1 block w-full rounded border p-2" type="password" autoComplete="new-password"
          value={password} onChange={(event) => setPassword(event.target.value)} required />
      </label>
      <label className="block">{t("form.confirm-password")}
        <input className="mt-1 block w-full rounded border p-2" type="password" autoComplete="new-password"
          value={confirmPassword} onChange={(event) => setConfirmPassword(event.target.value)} required />
      </label>
      <button className="rounded bg-indigo-800 px-5 py-2 text-white disabled:opacity-50" type="submit" disabled={busy}>
        {busy ? t("emailVerification.verifying") : t("emailVerification.submit")}
      </button>
    </form>}
    {message && <p className="mt-5" role="status">{message}</p>}
    <Link className="mt-6 inline-block text-indigo-700 underline" to="/login">{t("sign_in")}</Link>
  </main>;
}
